<template>
  <div id="gjwTableOperate">
    <template v-for="(btn, index) in buttons">
      <el-button v-show="isShow(btn, row)" :key="index" type="text" :disabled="isDisabled(btn, row)" @click="btn.clickCb && btn.clickCb({ row, rowIndex })">
        <i v-if="btn.icon" :class="btn.icon" :title="btn.text" />
        <span v-else>{{ btn.text }}</span>
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'GjwTableOperate',
  props: {
    // 操作按钮: icon,text,clickCb,disabled
    buttons: {
      type: Array,
      default() {
        return []
      }
    },
    // 行对象
    row: {
      type: Object,
      default() {
        return {}
      }
    },
    rowIndex: [String, Number]
  },
  methods: {
    isDisabled(btn, row) {
      return btn.disabled && btn.disabled(row)
    },
    isShow(btn, row) {
      if (!btn.show) {
        return true
      } else {
        return btn.show(row)
      }
    },

  }
}
</script>

<style scoped>

</style>
